/**
 * initialDataLoaded selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectInitialDataLoadeds = state => state.initialDataLoaded;
const selectNamespace = (state, props) => props.namespace;

type Namespace = string | string[];

const makeSelectInitialDataLoaded = (namespace?: Namespace) =>
    createDeepEqualSelector(
        [selectInitialDataLoadeds, selectNamespace],
        (initialDataLoadedsState, namespaceState) => {
            const namespaceValue = namespaceState || namespace;
            if (namespaceValue.constructor === Array) {
                return namespaceValue.reduce(
                    (acc, cur) => (acc ? true : initialDataLoadedsState[cur]),
                    false
                );
            }
            return initialDataLoadedsState[namespaceValue];
        }
    );

export { makeSelectInitialDataLoaded };
